import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
  isButton = true,
  title = '',
  action,
  href,
  moreStyle = '',
  type = 'button',
  disabled = false
}) => {

  const baseStyle =
    "font-bold rounded-md px-4 py-2 text-base focus:outline-none transition";

  const defaultColor =
    moreStyle.includes("bg-")
      ? ""
      : "bg-blue-600 hover:bg-blue-700 text-white";

  const disabledStyle = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";

  const style = `${baseStyle} ${defaultColor} ${disabledStyle} ${moreStyle}`;

  if (isButton) {
    return (
      <button
        className={style}
        type={type}
        onClick={action}
        disabled={disabled}
      >
        {title}
      </button>
    );
  }

  return (
    <Link to={href} className={style}>
      {title}
    </Link>
  );
};

export default Button;
